

































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'

@Component({
  components: { TcwGetsudoPicker }
})
export default class ShouninRouteLocalHeader extends Mixins(BaseComponent) {
  @Prop({ type: Boolean, default: true })
  protected editable!: boolean
  @Prop({ type: Boolean, default: true })
  protected editMode!: boolean

  @Emit()
  private changeEditMode(_editMode: boolean) {
    //
  }
}
